import React from 'react'

type BugsnagContextProps = {
  bugsnagClient: any
}

const BugsnagContext = React.createContext<BugsnagContextProps>({
  bugsnagClient: {}
})

export default BugsnagContext
